module.exports = __webpack_public_path__ + "media/bgm.dbf47f3f.mp3";